import {
  FETCH_CONTRACTSLAS,
  FETCH_CONTRACTSLAS_SUCCESS,
  FETCH_CONTRACTSLAS_ERROR,
  CREATE_CONTRACTSLAS,
  CREATE_CONTRACTSLAS_SUCCESS,
  CREATE_CONTRACTSLAS_ERROR,
  UPDATE_CONTRACTSLAS,
  UPDATE_CONTRACTSLAS_SUCCESS,
  UPDATE_CONTRACTSLAS_ERROR,
} from "../../mapping/actions/contractMappingActions";

import _ from "lodash";

interface SlaMappings {
  mappedContractSLAs: unknown[];
  unmappedContractSLAs: unknown[];
}

interface ContractMappingState {
  contractSlaMappings: SlaMappings | undefined;
  createdContractSlaMapping: unknown;
  updatedContractSlaMapping: unknown;
  fetchingContractSlas: boolean;
  fetchingContractSlasComplete: boolean;
  fetchingContractSlasError: unknown;
  creatingContractSla: boolean;
  creatingContractSlaComplete: boolean;
  creatingContractSlaError: unknown;
  updatingContractSla: boolean;
  updatingContractSlaComplete: boolean;
  updatingContractSlaError: unknown;
}

interface ContractMappingAction {
  type: string;
  payload: {
    data?: unknown;
  };
}

const updateSlaMappings = (updatedSlaMapping: { update: { id: unknown; [key: string]: unknown } }, existingSlaMappings: SlaMappings) => {
  return {
    ...existingSlaMappings,
    mappedContractSLAs: existingSlaMappings.mappedContractSLAs.map((esm) => {
      const existing = esm as Record<string, unknown>;
      if (existing.id === updatedSlaMapping.update.id) {
        return updatedSlaMapping.update;
      }
      return esm;
    }),
  };
};

const createSlaMappings = (createdSlaMapping: { create: Record<string, unknown> }, existingSlaMappings: SlaMappings) => {
  return {
    mappedContractSLAs: [
      ...existingSlaMappings.mappedContractSLAs,
      createdSlaMapping.create,
    ],
    unmappedContractSLAs: _.filter(
      existingSlaMappings.unmappedContractSLAs,
      (m: Record<string, unknown>) => {
        return (
          Number(m.contractCategory) !==
            Number(createdSlaMapping.create.contractCategory) &&
          Number(m.serviceLevelAgreementId) !==
            Number(createdSlaMapping.create.serviceLevelAgreementId)
        );
      }
    ),
  };
};

export function contractMappingReducer(
  state: ContractMappingState = {
    contractSlaMappings: undefined,
    createdContractSlaMapping: undefined,
    updatedContractSlaMapping: undefined,
    fetchingContractSlas: false,
    fetchingContractSlasComplete: false,
    fetchingContractSlasError: undefined,
    creatingContractSla: false,
    creatingContractSlaComplete: false,
    creatingContractSlaError: undefined,
    updatingContractSla: false,
    updatingContractSlaComplete: false,
    updatingContractSlaError: undefined,
  },
  action: ContractMappingAction
) {
  switch (action.type) {
    case FETCH_CONTRACTSLAS:
      return Object.assign({}, state, {
        fetchingContractSlas: true,
        fetchingContractSlasError: undefined,
        fetchingContractSlasComplete: false,
        contractSlaMappings: undefined,
      });
    case FETCH_CONTRACTSLAS_SUCCESS:
      return Object.assign({}, state, {
        fetchingContractSlas: false,
        fetchingContractSlasError: undefined,
        fetchingContractSlasComplete: true,
        contractSlaMappings: action.payload.data,
      });
    case FETCH_CONTRACTSLAS_ERROR:
      return Object.assign({}, state, {
        fetchingContractSlas: false,
        fetchingContractSlasComplete: false,
        fetchingContractSlasError: action.payload.data,
        contractSlaMappings: undefined,
      });
    case CREATE_CONTRACTSLAS:
      return Object.assign({}, state, {
        creatingContractSla: true,
        creatingContractSlaComplete: false,
        creatingContractSlaError: undefined,
        createdContractSlaMapping: undefined,
      });
    case CREATE_CONTRACTSLAS_SUCCESS:
      return Object.assign({}, state, {
        creatingContractSla: false,
        creatingContractSlaError: undefined,
        creatingContractSlaComplete: true,
        createdContractSlaMapping: action.payload.data,
        contractSlaMappings: state.contractSlaMappings
          ? createSlaMappings(
              action.payload.data as { create: Record<string, unknown> },
              state.contractSlaMappings
            )
          : state.contractSlaMappings,
      });
    case CREATE_CONTRACTSLAS_ERROR:
      return Object.assign({}, state, {
        creatingContractSla: false,
        creatingContractSlaComplete: false,
        creatingContractSlaError: action.payload.data,
        createdContractSlaMapping: undefined,
      });
    case UPDATE_CONTRACTSLAS:
      return Object.assign({}, state, {
        updatingContractSla: true,
        updatingContractSlaError: undefined,
        updatingContractSlaComplete: false,
        updatedContractSlaMapping: undefined,
      });
    case UPDATE_CONTRACTSLAS_SUCCESS:
      return Object.assign({}, state, {
        updatingContractSla: false,
        updatingContractSlaError: undefined,
        updatingContractSlaComplete: true,
        updatedContractSlaMapping: action.payload.data,
        contractSlaMappings: state.contractSlaMappings
          ? updateSlaMappings(
              action.payload.data as { update: { id: unknown; [key: string]: unknown } },
              state.contractSlaMappings
            )
          : state.contractSlaMappings,
      });
    case UPDATE_CONTRACTSLAS_ERROR:
      return Object.assign({}, state, {
        updatingContractSla: false,
        updatingContractSlaComplete: false,
        updatingContractSlaError: action.payload.data,
        updatedContractSlaMapping: undefined,
      });
    default:
      return state;
  }
}
